export default __webpack_public_path__ + "static/media/remplisVert.ee1d7011.png";